import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import * as RestService from '../../services/eisRest';

import * as Yup from 'yup';
import moment from 'moment';
import * as AuthService from '../../services/auth';
import Button from '../../components/button/Button';
import * as ActionTypes from '../../store/actions';
import Select from 'react-select';

const GeneralApprove = (props) => {
  const { t, i18n } = useTranslation();
  const [approveRequest, setApproveRequest] = useState(null);
  const [isResult, setIsResult] = useState(false);

  const queryParams = new URLSearchParams(window.location.search);
  const approveRequestId = queryParams.get('id');

  const onSelectLanguage = (selectedOption) => {
    i18n.changeLanguage(selectedOption.value);
  };

  useEffect(() => {
    RestService.callAnyApi(`attendance/getApproveRequest?id=${approveRequestId}`, null)
      .then((data) => {
        setApproveRequest(data);
        if (data.response != null) {
          setIsResult(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [approveRequestId]);

  const agree = () => {
    approveRequest.response = 'OK';
    formik.handleSubmit();
  };

  const notAgree = () => {
    approveRequest.response = 'NOK';
    formik.handleSubmit();
  };

  function onClose() {
    window.opener = null;
    window.open('', '_self');
    window.close();
  }

  const showError = (error, serverMessage) => {
    if (serverMessage == null) {
      toast.error(
        (error.response &&
          error.response.data &&
          error.response.data.message &&
          error.responseMessage) ||
          t('general.message.failed')
      );
    } else {
      toast.error(t('attendance.label.' + serverMessage));
    }
  };

  const save = (url, values) => {
    approveRequest.responseText = values.responseText;

    RestService.callAnyApi(url, approveRequest)
      .then((data) => {
        if (data.responseMessage === 'OK') {
          setApproveRequest(data.responseObject);
          toast.success(t('general.message.saveSucceed'));
          setIsResult(true);
          onClose();
        } else {
          showError(null, data.responseMessage);
        }
      })
      .catch((error) => {
        showError(error, null);
      });
  };

  const formik = useFormik({
    initialValues: {
      responseText: '',
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      save('attendance/saveApproveResponse', values);
    },
  });

  document.getElementById('root').classList = 'hold-transition login-page';

  const languageOptions = [
    { value: 'en', label: 'English' },
    { value: 'sk', label: 'Slovak' },
  ];

  return (
    <div className="login-box">
      <div className="card card-outline card-primary">
        <div className="card-header text-center">
          <Link to="/" className="h1">
            <b>E</b>
            <span>IS</span>
          </Link>
        </div>
        <div className="card-body">
          <p className="login-box-msg h3">{t('attendance.label.approveRequest')}</p>
          <form>
            <div className="mb-3" style={isResult ? {} : { display: 'none' }}>
              <span className="font-weight-bold text-primary text-center">
                {approveRequest && approveRequest.response !== 'ERR'
                  ? t('attendance.label.decisionSelected') + approveRequest.response
                  : ''}
              </span>
              <span className="font-weight-bold text-primary text-center">
                {approveRequest && approveRequest.response === 'ERR'
                  ? t('attendance.label.eventForApproveNotExist')
                  : ''}
              </span>
            </div>
            <div className="mb-3">
              {t('attendance.label.event')}:{' '}
              <span className="font-weight-bold">
                {approveRequest ? t('attendance.label.' + approveRequest.event) : '???'}
              </span>
            </div>
            <div className="mb-3">
              {t('attendance.label.whoAsks')}:{' '}
              <span className="font-weight-bold">{approveRequest ? approveRequest.person : ''}</span>
            </div>
            <div className="mb-3">
              {t('attendance.label.from')}:{' '}
              <span className="font-weight-bold">
                {moment(approveRequest ? approveRequest.start : 0).format('DD.MM.YYYY HH:mm')}
              </span>{' '}
              {t('attendance.label.to')}{' '}
              <span className="font-weight-bold">
                {moment(approveRequest ? approveRequest.stop : 0).format('DD.MM.YYYY HH:mm')}
              </span>
            </div>
            <div className="mb-3">{t('general.label.description')}: {approveRequest ? approveRequest.description : ''}</div>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <label className="font-weight-normal">{t('general.label.proclamation')}:</label>
                  <textarea className="form-control" rows="3" placeholder="" {...formik.getFieldProps('responseText')}></textarea>
                </div>
                {formik.touched.responseText && formik.errors.responseText ? (
                  <div style={{ color: 'red' }}>{formik.errors.responseText}</div>
                ) : null}
              </div>
            </div>
            <div className="row">
              <div className="col-12" style={!isResult ? {} : { display: 'none' }}>
                <Button block className="btn btn-block btn-danger" onClick={notAgree}>
                  {t('general.button.notagree')}
                </Button>
                <Button block className="btn btn-block btn-success" onClick={agree}>
                  {t('general.button.agree')}
                </Button>
              </div>
            </div>
          </form>
          <div className="float-right" style={{ marginTop: '20px' }}>
            <Select options={languageOptions} onChange={onSelectLanguage} placeholder="Select Language" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeneralApprove;
